import React, { useState, useRef, useEffect } from 'react';
//interface FrameExtractorProps { }
export const FrameExtractor = () => {
    const [videoFile, setVideoFile] = useState(null);
    const [videoDuration, setVideoDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const [videoUrl, setVideoUrl] = useState('');
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const fileInputRef = useRef(null);
    useEffect(() => {
        return () => {
            if (videoUrl) {
                URL.revokeObjectURL(videoUrl);
            }
        };
    }, [videoUrl]);
    const handleFileUpload = (event) => {
        const file = event.target.files?.[0];
        if (file && file.type.startsWith('video/')) {
            setVideoFile(file);
            if (videoUrl) {
                URL.revokeObjectURL(videoUrl);
            }
            const url = URL.createObjectURL(file);
            setVideoUrl(url);
        }
    };
    const handleVideoLoad = () => {
        if (videoRef.current) {
            setVideoDuration(videoRef.current.duration);
            setCurrentTime(0);
            extractFrame(0);
            console.log("Video loaded");
        }
    };
    const handleVideoTimeUpdate = () => {
        if (videoRef.current) {
            setCurrentTime(videoRef.current.currentTime);
        }
    };
    const handleSliderChange = (event) => {
        const time = parseFloat(event.target.value);
        setCurrentTime(time);
        if (videoRef.current) {
            videoRef.current.currentTime = time;
        }
    };
    const extractFrame = (time) => {
        if (!videoRef.current || !canvasRef.current)
            return;
        const video = videoRef.current;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        if (!ctx)
            return;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    };
    const handleVideoSeeked = () => {
        extractFrame();
    };
    const handleVideoPause = () => {
        if (videoRef.current) {
            extractFrame(videoRef.current.currentTime);
        }
    };
    const generateFrameFileName = (originalFileName) => {
        // Remove file extension and existing timestamp if present
        let baseName = originalFileName.replace(/\.(mp4|mov|avi|wmv|flv|webm|mkv)$/i, '');
        baseName = baseName.replace(/-\d{10,13}\.png$/, '');
        // Format current timestamp as YYYYMMDD-HHmmss
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const timestamp = `${year}${month}${day}-${hours}${minutes}${seconds}`;
        // Create new filename with timestamp
        return `${baseName}-${timestamp}.png`;
    };
    const downloadImage = () => {
        if (!canvasRef.current)
            return;
        const canvas = canvasRef.current;
        const link = document.createElement('a');
        // Use original filename if available, otherwise generate default name
        let fileName = 'frame.png';
        if (videoFile && videoFile.name) {
            fileName = generateFrameFileName(videoFile.name);
        }
        else {
            fileName = `frame-${Math.floor(currentTime)}.png`;
        }
        link.download = fileName;
        link.href = canvas.toDataURL();
        link.click();
    };
    const jumpToLastFrame = () => {
        if (videoRef.current && videoDuration > 0) {
            videoRef.current.currentTime = videoDuration;
            setCurrentTime(videoDuration);
            extractFrame(videoDuration);
        }
    };
    const jumpToFirstFrame = () => {
        if (videoRef.current) {
            videoRef.current.currentTime = 0;
            setCurrentTime(0);
            extractFrame(0);
        }
    };
    const togglePlayPause = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                videoRef.current.play();
            }
            else {
                videoRef.current.pause();
            }
        }
    };
    const stepFrameForward = () => {
        if (videoRef.current && videoFile) {
            // Get current time and increment by 1 frame (assuming 30fps)
            const currentTime = videoRef.current.currentTime;
            const frameDuration = 1 / 30; // 1/30 seconds for 30fps
            const newTime = Math.min(currentTime + frameDuration, videoDuration);
            videoRef.current.currentTime = newTime;
            setCurrentTime(newTime);
            extractFrame(newTime);
        }
    };
    const stepFrameBackward = () => {
        if (videoRef.current && videoFile) {
            // Get current time and decrement by 1 frame (assuming 30fps)
            const currentTime = videoRef.current.currentTime;
            const frameDuration = 1 / 30; // 1/30 seconds for 30fps
            const newTime = Math.max(currentTime - frameDuration, 0);
            videoRef.current.currentTime = newTime;
            setCurrentTime(newTime);
            extractFrame(newTime);
        }
    };
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };
    return (React.createElement("div", { className: "card w-100 border-0 rounded-0" },
        React.createElement("div", { className: "card-header rounded-0" },
            React.createElement("h3", { className: "card-title mb-0" }, "Video Frame Extractor")),
        React.createElement("div", { className: "row g-4 mx-3 mb-3 mt-3" },
            React.createElement("div", { className: "col-12 col-lg-5" },
                React.createElement("div", { className: "mb-4" },
                    React.createElement("label", { htmlFor: "videoUpload", className: "form-label" }, "Upload MP4 Video"),
                    React.createElement("input", { ref: fileInputRef, type: "file", className: "form-control", id: "videoUpload", accept: "video/mp4,video/*", onChange: handleFileUpload })),
                videoFile && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "mb-4" },
                        React.createElement("video", { ref: videoRef, src: videoUrl, className: "w-100", style: { maxHeight: '400px', objectFit: 'contain' }, onLoadedMetadata: handleVideoLoad, onSeeked: handleVideoSeeked, onTimeUpdate: handleVideoTimeUpdate, onPause: handleVideoPause, controls: false, muted: true })),
                    videoDuration > 0 && (React.createElement("div", { className: "mb-4" },
                        React.createElement("label", { htmlFor: "timeSlider", className: "form-label" },
                            "Position: ",
                            currentTime.toFixed(3),
                            " / ",
                            videoDuration.toFixed(3)),
                        React.createElement("input", { type: "range", className: "form-range", id: "timeSlider", min: "0", max: videoDuration, step: "0.1", value: currentTime, onChange: handleSliderChange }))),
                    React.createElement("div", { className: "d-flex gap-2 mb-4" },
                        React.createElement("button", { type: "button", className: "btn btn-secondary ms-auto", onClick: jumpToFirstFrame, disabled: !videoFile || videoDuration <= 0 },
                            React.createElement("i", { className: "fas fa-fast-backward " })),
                        React.createElement("button", { type: "button", className: "btn btn-secondary", onClick: stepFrameBackward, disabled: !videoFile || videoDuration <= 0 || !videoRef.current?.paused },
                            React.createElement("i", { className: "fas fa-step-backward " })),
                        React.createElement("button", { type: "button", className: "btn btn-secondary", onClick: togglePlayPause, disabled: !videoFile || videoDuration <= 0 },
                            React.createElement("i", { className: "fas fa-play " })),
                        React.createElement("button", { type: "button", className: "btn btn-secondary", onClick: stepFrameForward, disabled: !videoFile || videoDuration <= 0 || !videoRef.current?.paused },
                            React.createElement("i", { className: "fas fa-step-forward" })),
                        React.createElement("button", { type: "button", className: "btn btn-secondary me-auto", onClick: jumpToLastFrame, disabled: !videoFile || videoDuration <= 0 },
                            React.createElement("i", { className: "fas fa-fast-forward " }))))),
                !videoFile && (React.createElement("div", { className: "text-center text-muted mt-4" },
                    React.createElement("i", { className: "bi bi-film", style: { fontSize: '3rem' } }),
                    React.createElement("p", { className: "mt-2" }, "Upload an MP4 video to get started")))),
            React.createElement("div", { className: "col-12 col-lg-7" },
                React.createElement("h2", { className: "h5 fw-semibold text-secondary mb-3" }, "Current Frame"),
                React.createElement("div", { className: "border border-2 border-secondary-subtle rounded-3 p-4 text-center min-vh-50 d-flex align-items-center justify-content-center", style: { minHeight: 400 } }, videoFile ? (React.createElement("div", { className: "w-100" }, videoDuration > 0 && currentTime >= 0 ? (React.createElement("div", { className: "w-100" },
                    React.createElement("canvas", { ref: canvasRef, className: "img-fluid rounded shadow mb-3", style: { maxHeight: '350px', objectFit: 'contain' } }),
                    React.createElement("br", null),
                    React.createElement("button", { type: "button", className: "btn btn-primary", onClick: downloadImage, disabled: !canvasRef.current },
                        React.createElement("i", { className: "bi bi-download me-2" }),
                        "Download Frame as PNG"))) : (React.createElement("div", { className: "text-muted w-100" },
                    React.createElement("i", { className: "bi bi-image", style: { fontSize: '3rem' } }),
                    React.createElement("div", null, "Frame will appear here"))))) : (React.createElement("div", { className: "text-muted w-100" },
                    React.createElement("i", { className: "bi bi-film", style: { fontSize: '3rem' } }),
                    React.createElement("div", null, "Upload a video to see frame preview"))))))));
};
export default FrameExtractor;
